/* BIORA PROTOCOL — storefront interactions */
(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    $$('[data-gallery]', root).forEach(function (gallery) {
      var track = $('[data-gallery-track]', gallery);
      if (!track || track.dataset.ready) return;
      track.dataset.ready = '1';
      var thumbs = $$('[data-gallery-thumb]', gallery);
      var dots = $$('[data-gallery-dot]', gallery);

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var i = parseInt(thumb.dataset.index, 10) || 0;
          track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        });
      });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
          dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
          ticking = false;
        });
      }, { passive: true });
    });
  }

  /* ---------- Order boxes: packs, COD form, checkout ---------- */
  function selectedInput(box) {
    return $$('input[data-bundle]', box).filter(function (i) { return i.checked; })[0];
  }

  function scopeOf(box) {
    return box.closest('[data-biora-hero]') || box;
  }

  function syncBox(box) {
    var sel = selectedInput(box);
    $$('input[data-bundle]', box).forEach(function (i) {
      var label = i.closest('.b-bundle');
      if (label) label.classList.toggle('is-selected', i.checked);
    });
    if (!sel) return;
    var scope = scopeOf(box);
    $$('[data-selected-price]', scope).forEach(function (el) { el.textContent = sel.dataset.price; });
    $$('[data-selected-title]', scope).forEach(function (el) { el.textContent = sel.dataset.title; });
    var pack = $('[data-cod-pack]', box);
    var price = $('[data-cod-price]', box);
    var variant = $('[data-cod-variant]', box);
    if (pack) pack.value = sel.dataset.title + (sel.dataset.detail ? ' (' + sel.dataset.detail + ')' : '');
    if (price) price.value = sel.dataset.price;
    if (variant) variant.value = sel.value;
    var link = $('[data-buy-link]', box);
    if (link && link.dataset.base) link.href = link.dataset.base + '?variant=' + sel.value;
  }

  function normalizePhone(v) {
    var d = (v || '').replace(/[\s.\-()]/g, '');
    if (d.indexOf('00212') === 0) d = '+212' + d.slice(5);
    if (d.indexOf('+212') === 0) d = '0' + d.slice(4);
    if (/^[5-7]\d{8}$/.test(d)) d = '0' + d;
    return d;
  }

  function validPhone(v) {
    return /^0[5-7]\d{8}$/.test(normalizePhone(v));
  }

  function jsonPost(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : '{}'
    });
  }

  function initCodForm(box) {
    var form = $('form[data-cod-form]', box) || $('.b-cod', box);
    if (!form || form.tagName !== 'FORM') return;
    var phone = $('[data-cod-phone]', form);
    var phoneErr = $('[data-cod-phone-error]', form);

    if (phone) {
      phone.addEventListener('input', function () {
        phone.classList.remove('is-invalid');
        if (phoneErr) phoneErr.hidden = true;
      });
    }

    form.addEventListener('submit', function (e) {
      syncBox(box);
      if (phone && !validPhone(phone.value)) {
        e.preventDefault();
        phone.classList.add('is-invalid');
        if (phoneErr) phoneErr.hidden = false;
        phone.focus();
        return;
      }
      if (phone) phone.value = normalizePhone(phone.value);
      var body = $('[data-cod-body]', form);
      var pack = $('[data-cod-pack]', form);
      var price = $('[data-cod-price]', form);
      if (body) {
        body.value = 'Nouvelle commande — Paiement à la livraison. Pack : ' +
          (pack ? pack.value : '') + ' · Montant : ' + (price ? price.value : '');
      }
      var btn = $('[data-cod-submit]', form);
      if (btn) btn.setAttribute('aria-busy', 'true');
      try {
        if (typeof window.fbq === 'function') window.fbq('track', 'Lead');
      } catch (err) {}
    });
  }

  function initCheckoutButton(box) {
    var btn = $('[data-buy-now]', box);
    var err = $('[data-buy-error]', box);
    if (!btn) return;
    btn.addEventListener('click', function () {
      var sel = selectedInput(box);
      if (!sel) {
        if (err) { err.textContent = 'Choisissez votre pack pour continuer.'; err.hidden = false; }
        return;
      }
      var routes = window.BioraRoutes || { cartAdd: '/cart/add', cartClear: '/cart/clear', checkout: '/checkout' };
      btn.setAttribute('aria-busy', 'true');
      if (err) err.hidden = true;
      jsonPost(routes.cartClear + '.js')
        .then(function () {
          return jsonPost(routes.cartAdd + '.js', {
            items: [{ id: parseInt(sel.value, 10), quantity: parseInt(sel.dataset.qty, 10) || 1 }]
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('add_failed');
          return res.json();
        })
        .then(function () { window.location.href = routes.checkout; })
        .catch(function () {
          btn.removeAttribute('aria-busy');
          if (err) {
            err.textContent = 'Ce pack est momentanément indisponible. Choisissez un autre pack ou réessayez dans un instant.';
            err.hidden = false;
          }
        });
    });
  }

  /* Shopify marks every contact form as sent after one submission.
     Keep the confirmation only in the form that was sent (#form-id in the URL). */
  function scopeSuccess(root) {
    var blocks = $$('[data-success-for]', root);
    if (!blocks.length) return;
    var hash = (window.location.hash || '').replace('#', '');
    var shown = null;
    blocks.forEach(function (box) {
      var form = box.closest('form');
      var fields = form ? $('[data-fields-after-success]', form) : null;
      var mine = !hash || hash === box.getAttribute('data-success-for');
      if (mine) {
        if (!shown) shown = box;
      } else {
        box.parentNode.removeChild(box);
        if (fields) fields.hidden = false;
      }
    });
    if (shown && !shown.dataset.shown) {
      shown.dataset.shown = '1';
      shown.scrollIntoView({ block: 'center' });
      shown.focus({ preventScroll: true });
    }
  }

  function initBuy(root) {
    $$('[data-buybox]', root).forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      $$('input[data-bundle]', box).forEach(function (i) {
        i.addEventListener('change', function () { syncBox(box); });
      });
      syncBox(box);
      initCodForm(box);
      initCheckoutButton(box);
    });

    scopeSuccess(root);
  }

  /* ---------- Delivery estimate (24h/48h, Sundays skipped) ---------- */
  function initDelivery(root) {
    var days = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
    var months = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
    function addBusinessDays(date, n) {
      var d = new Date(date.getTime());
      var count = 0;
      while (count < n) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0) count++;
      }
      return d;
    }
    function fmt(d) { return days[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()]; }

    $$('[data-delivery]', root).forEach(function (el) {
      var now = new Date();
      var range = $('[data-delivery-range]', el);
      if (range) range.textContent = fmt(addBusinessDays(now, 1)) + ' et le ' + fmt(addBusinessDays(now, 2));
      el.hidden = false;
    });
  }

  /* ---------- Sticky mobile bar ---------- */
  var stickyObserver = null;
  function initSticky() {
    var bar = $('[data-sticky]');
    var target = $('#biora-buy-cta') || $('#biora-buy .b-bundles') || $('#biora-buy');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    if (stickyObserver) stickyObserver.disconnect();
    stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var scrolledPast = entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', !entry.isIntersecting && scrolledPast);
      });
    });
    stickyObserver.observe(target);
  }

  /* ---------- Smooth scroll to order box / anchors ---------- */
  function initScrollLinks(root) {
    $$('[data-scroll-buy], [data-scroll-to]', root).forEach(function (link) {
      if (link.dataset.ready) return;
      link.dataset.ready = '1';
      link.addEventListener('click', function (e) {
        var target = null;
        if (link.hasAttribute('data-scroll-buy')) {
          target = document.getElementById('biora-buy') || document.getElementById('biora-order');
        } else {
          var hash = (link.getAttribute('href') || '').split('#')[1];
          if (hash) target = document.getElementById(hash);
        }
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- Cortisol pillars tabs ---------- */
  function initPillars(root) {
    $$('[data-pillars]', root).forEach(function (wrap) {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      var tabs = $$('[data-pillar-tab]', wrap);
      var panels = $$('[data-pillar-panel]', wrap);
      function activate(i, focus) {
        tabs.forEach(function (t, k) {
          var on = k === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p, k) { p.hidden = k !== i; });
        if (focus) tabs[i].focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { activate(i, false); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); activate((i + 1) % tabs.length, true); }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); activate((i - 1 + tabs.length) % tabs.length, true); }
        });
      });
    });
  }

  /* ---------- 21-day graph: draws when visible ---------- */
  function initGraph(root) {
    var graphs = $$('[data-graph]', root);
    if (!graphs.length) return;
    if (!('IntersectionObserver' in window)) {
      graphs.forEach(function (g) { g.classList.add('is-drawn'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-drawn');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.35 });
    graphs.forEach(function (g) { io.observe(g); });
  }

  function init(root) {
    root = root || document;
    initGallery(root);
    initBuy(root);
    initDelivery(root);
    initScrollLinks(root);
    initGraph(root);
    initPillars(root);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target && e.target.matches && e.target.matches('[data-pillar-tab]') ? e.target : null;
    if (tab) tab.click();
  });
})();
